import { CommanderThunkAction } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { logError } from './common';
import { APP_RELOAD_REQUESTED } from './types';

const MAX_APP_LIFETIME = 60 * 60 * 1000;

export const scheduleAppCleanup = (): CommanderThunkAction => (dispatch) => {
    window.setTimeout(() => {
        const enterpriseId = getCurrentEnterpriseId();

        dispatch(createAction(APP_RELOAD_REQUESTED));
        dispatch(
            logError({
                type: 'force-reload',
                message: 'Forced reload scheduled application cleaner.',
                context: { enterpriseId },
            })
        );
    }, MAX_APP_LIFETIME);
};
